import React, { Component, Fragment } from 'react';
import { Translate } from 'react-redux-i18n';
import { css } from 'aphrodite';
import styles from './TriggerList.styles';
import { CRITERIA_OPERATION_TYPES } from '../../../constants/triggers';

import ActionCard from './actioncard/ActionCard';
import Button from '../../inputs/button/Button';
import Icon from '../../common/icon/Icon';
import TriggerCard from './triggercard/TriggerCard';

class TriggerList extends Component {
  render() {
    if (!this.props.data || !this.props.data.length) {
      return (
        <div className={css(styles.base, styles.noTriggers, this.props.styles)}>
          <Icon value="briefcase" styles={styles.icon} />
          <Translate
            value="add.workflows.noDataFirst"
            className={css(styles.text)}
          />
          <Translate
            value="add.workflows.noDataSecond"
            className={css(styles.text)}
          />
          <Button styles={styles.btn} onClick={this.props.handleAdd}>
            {this.props.addText}
          </Button>
        </div>
      );
    }
    return (
      <div className={css(styles.base, this.props.styles)}>
        {this.props.data.map((trigger, i) => (
          <div className={css(styles.trigger)} key={i}>
            {trigger.criteria.length &&
              trigger.criteria
                .reduce((list, criteria) => {
                  if (
                    criteria.operation === CRITERIA_OPERATION_TYPES.OR ||
                    !list.length
                  ) {
                    list.push([criteria]);
                  } else {
                    list[list.length - 1].push(criteria);
                  }
                  return list;
                }, [])
                .map((criteria, j, original) => (
                  <Fragment key={j}>
                    <TriggerCard
                      criterias={criteria}
                      showActions={original.length - 1 === j}
                      onEdit={() => this.props.onEdit(trigger)}
                      onDelete={() => this.props.onDelete(trigger)}
                    />
                    <div className={css(styles.separator)} />
                  </Fragment>
                ))}
            {!trigger.action ? (
              <Button
                styles={styles.addAction}
                onClick={() => this.props.handleAddAction(trigger)}
              >
                <Translate value="add.action.add" />
              </Button>
            ) : (
              <ActionCard
                action={trigger.action}
                showActions={true}
                onEdit={() => this.props.onEditAction(trigger.action)}
                onDelete={() => this.props.onDeleteAction(trigger.action)}
              />
            )}
          </div>
        ))}
      </div>
    );
  }
}

export default TriggerList;



// WEBPACK FOOTER //
// ./src/components/data/triggerlist/TriggerList.js